import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Band from './components/Band';
import Collections from './components/Collections';
import Universe from './components/Universe';
import Manifesto from './components/Manifesto';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    (window as any).scrollTo = scrollTo;
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Band />
      <Collections />
      <Universe />
      <Manifesto />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;